export function getRestrictedMedia(url: string): string {
  // Leave external URLs untouched
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }

  // Match: /mediabrowser/[images or files]/<uuid>/<anyfilename>.<ext>
  const pattern = /^\/mediabrowser\/(images|files)\/([a-z0-9-]+)\/([^/]+)\.([a-z0-9]+)$/i;
  const match = url.match(pattern);

  if (match) {
    const uuid = match[2];
    const ext = match[4];
    return `/images/${uuid}/filename.${ext}`;
  }

  return url;
}
